const newTask = {
  id: null,
  title: "",
  body: "",
  category: ""
};

export default newTask;
